var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.7803 6.22011C21.0732 6.51301 21.0732 6.98788 20.7803 7.28077L10.2803 17.7803C9.98743 18.0732 9.51259 18.0732 9.21969 17.7803L3.96969 12.5308C3.67679 12.2379 3.67677 11.763 3.96965 11.4701C4.26253 11.1772 4.7374 11.1772 5.03031 11.4701L9.74999 16.1893L19.7197 6.22009C20.0126 5.9272 20.4875 5.92721 20.7803 6.22011Z", fill: "#303030" })
  );
});